var render = function render() {
  var _vm$task$attributes, _vm$task$attributes$p
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("tr", [
    _c(
      "td",
      [
        _vm.status.shape !== undefined
          ? _c("studip-icon", {
              attrs: {
                shape: _vm.status.shape,
                role: _vm.status.role,
                title: _vm.status.description,
                "aria-hidden": "true",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "sr-only",
          },
          [_vm._v(_vm._s(_vm.status.description))]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("td", [
      _vm.user
        ? _c(
            "span",
            [
              _c("studip-icon", {
                attrs: {
                  shape: "person2",
                  role: "info",
                  "aria-hidden": "true",
                  title: _vm.$gettext("Teilnehmende Person"),
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "sr-only",
                },
                [_vm._v(_vm._s(_vm.$gettext("Teilnehmende Person")))]
              ),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.user.attributes["formatted-name"]) +
                  "\n        "
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.group
        ? _c(
            "span",
            [
              _c("studip-icon", {
                attrs: {
                  shape: "group2",
                  role: "info",
                  "aria-hidden": "true",
                  title: _vm.$gettext("Gruppe"),
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "sr-only",
                },
                [_vm._v(_vm._s(_vm.$gettext("Gruppe")))]
              ),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.group.attributes["name"]) +
                  "\n        "
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "td",
      {
        staticClass: "responsive-hidden",
      },
      [
        _vm.task.attributes.submitted
          ? _c(
              "a",
              {
                attrs: {
                  href: _vm.getLinkToElement(_vm.element),
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.element.attributes.title) +
                    "\n        "
                ),
              ]
            )
          : _c("span", [_vm._v(_vm._s(_vm.element.attributes.title))]),
      ]
    ),
    _vm._v(" "),
    _c("td", [
      _vm._v(
        _vm._s(
          ((_vm$task$attributes = _vm.task.attributes) === null ||
          _vm$task$attributes === void 0
            ? void 0
            : (_vm$task$attributes$p = _vm$task$attributes.progress) === null ||
              _vm$task$attributes$p === void 0
            ? void 0
            : _vm$task$attributes$p.toFixed(2)) || "-.--"
        ) + "%"
      ),
    ]),
    _vm._v(" "),
    _c("td", [
      _vm._v(
        _vm._s(_vm.getReadableDate(_vm.task.attributes["submission-date"]))
      ),
    ]),
    _vm._v(" "),
    _c(
      "td",
      [
        _vm.task.attributes.submitted
          ? _c("studip-icon", {
              attrs: {
                shape: "accept",
                role: "status-green",
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "td",
      {
        staticClass: "responsive-hidden",
      },
      [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.task.attributes.renewal === "pending",
                expression: "task.attributes.renewal === 'pending'",
              },
            ],
            staticClass: "button",
            on: {
              click: function click($event) {
                return _vm.$emit("solve-renewal", _vm.task)
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$gettext("Anfrage bearbeiten")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.task.attributes.renewal === "declined",
                expression: "task.attributes.renewal === 'declined'",
              },
            ],
          },
          [
            _c("studip-icon", {
              attrs: {
                shape: "decline",
                role: "status-red",
              },
            }),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$gettext("Anfrage abgelehnt")) +
                "\n        "
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.task.attributes.renewal === "granted",
                expression: "task.attributes.renewal === 'granted'",
              },
            ],
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$gettext("verlängert bis")) +
                ":\n            " +
                _vm._s(
                  _vm.getReadableDate(_vm.task.attributes["renewal-date"])
                ) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _vm.task.attributes.renewal === "declined" ||
        _vm.task.attributes.renewal === "granted"
          ? _c("studip-icon", {
              staticClass: "edit",
              attrs: {
                title: _vm.$gettext("Anfrage bearbeiten"),
                shape: "edit",
              },
              on: {
                click: function click($event) {
                  return _vm.$emit("solve-renewal", _vm.task)
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "td",
      {
        staticClass: "responsive-hidden",
      },
      [
        _vm.feedback
          ? _c(
              "span",
              {
                attrs: {
                  title: _vm.$gettextInterpolate(
                    _vm.$gettext("Feedback geschrieben am: %{ date }"),
                    {
                      date: _vm.getReadableDate(
                        _vm.feedback.attributes["chdate"]
                      ),
                    }
                  ),
                },
              },
              [
                _c("studip-icon", {
                  attrs: {
                    shape: "accept",
                    role: "status-green",
                  },
                }),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$gettext("Feedback gegeben")) +
                    "\n            "
                ),
                _c("studip-icon", {
                  staticClass: "edit",
                  attrs: {
                    title: _vm.$gettext("Feedback bearbeiten"),
                    shape: "edit",
                  },
                  on: {
                    click: function click($event) {
                      return _vm.$emit("edit-feedback", _vm.feedback)
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.feedback && _vm.task.attributes.submitted,
                expression: "!feedback && task.attributes.submitted",
              },
            ],
            staticClass: "button",
            on: {
              click: function click($event) {
                return _vm.$emit("add-feedback", _vm.task)
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$gettext("Feedback geben")) +
                "\n        "
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }